module.exports = __webpack_public_path__ + "491e6dbb0f2a1f2aeaf8b630e6e6050b.svg";